/**
 * @file LoginPage.js
 * @description View para a página de login.
 */
import { useState } from "react";
import { LogIn, Loader, Shield, AlertTriangle } from "lucide-react";

const LoginPage = ({ onLogin, error, setView }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    await onLogin(email, password);
    setIsLoading(false);
  };

  return (
    <div className="flex items-center justify-center min-h-[75vh] px-4 py-8">
      <div className="w-full max-w-sm">
        {/* Ícone + título da página */}
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-ouro/15 border border-ouro/30 mb-4">
            <Shield size={26} className="text-ouro" />
          </div>
          <h2 className="text-2xl font-black text-white">Acesso Restrito</h2>
          <p className="mt-1 text-sm text-gray-400">Área exclusiva para administradores.</p>
        </div>

        {/* Card do formulário */}
        <div className="bg-campo-900 border border-campo-700/60 rounded-2xl p-6 shadow-xl">
          <form onSubmit={handleSubmit} autoComplete="off" className="space-y-4">
            <div>
              <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1.5">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="off"
                className="w-full bg-campo-950 border border-campo-600 text-white px-3 py-2.5 rounded-lg text-sm placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-ouro focus:border-transparent transition-shadow"
                placeholder="seu@email.com"
              />
            </div>

            <div>
              <label className="block text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1.5">
                Senha
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength="6"
                autoComplete="new-password"
                className="w-full bg-campo-950 border border-campo-600 text-white px-3 py-2.5 rounded-lg text-sm placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-ouro focus:border-transparent transition-shadow"
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div className="flex items-center gap-2 p-3 bg-red-500/10 border border-red-500/30 rounded-lg">
                <AlertTriangle size={14} className="text-red-400 flex-shrink-0" />
                <p className="text-red-400 text-sm">{error}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={isLoading}
              className="w-full flex items-center justify-center gap-2 bg-ouro hover:bg-ouro-light disabled:bg-gray-600 disabled:cursor-not-allowed text-campo-950 disabled:text-gray-400 font-bold py-2.5 px-4 rounded-lg transition-colors text-sm"
            >
              {isLoading ? (
                <><Loader size={15} className="animate-spin" /> Entrando...</>
              ) : (
                <><LogIn size={15} /> Entrar</>
              )}
            </button>
          </form>
        </div>

        <button
          onClick={() => setView("DASHBOARD")}
          className="w-full text-center text-sm text-gray-500 hover:text-ouro mt-4 py-2 transition-colors"
        >
          ← Voltar ao Dashboard
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
